export interface ExtendedDataPerson {
  externalObjectId: string;
  objectName: string;
  emailAddress: string;
}

export interface ExchangeExtendedData {
  exposedBy: ExtendedDataPerson;
  exposedPersonCount: number;
  someExposedToRefs: ExtendedDataPerson[];
}

export const ExtendedDataHelper = {
  to_email_provider(extendedData: string): ExchangeExtendedData {
    try {
      return JSON.parse(extendedData) as ExchangeExtendedData;
    } catch (e) {
      return {
        exposedBy: { emailAddress: "", externalObjectId: "", objectName: "" },
        exposedPersonCount: 0,
        someExposedToRefs: [],
      };
    }
  },
};
